import React from "react";
import styles from "./SpinnerStyles.module.scss";

export const LoadingSpinner: React.FC = () => {
    return <div className={`${styles.spinner} spinner-border-color`}></div>;
};
